import React from 'react'

const SettingGroup = () => {
  return (
    <div>Group</div>
  )
}

export default SettingGroup